import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectPercentageLossOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.percentageLoss.options;

export const options = setCalculationModeProjectPercentageLossOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PROJECT_PERCENTAGE_LOSS_OPTIONS',
  []
);
